import React from "react";
var __jsx = React.createElement;
import { Modal as MantineModal } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { MODAL_Z_INDEX } from "./modal-config";
/** Shared SDS modal: consistent header, scrollable body, optional footer, and stacking. */
export function Modal(_ref) {
  var opened = _ref.opened,
    onClose = _ref.onClose,
    title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "lg" : _ref$size,
    footer = _ref.footer,
    closeTestId = _ref.closeTestId,
    children = _ref.children;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(MantineModal, {
    opened: opened,
    onClose: onClose,
    centered: true,
    size: size,
    zIndex: MODAL_Z_INDEX,
    closeButtonProps: {
      "data-testid": closeTestId,
      "aria-label": t("close", {
        defaultValue: "Close"
      })
    },
    styles: {
      header: {
        alignItems: "flex-start",
        marginBottom: 20,
        paddingBottom: 16,
        borderBottom: "1px solid var(--sds-border-base-default)"
      }
    },
    title: /*#__PURE__*/React.createElement("span", {
      className: "flex flex-col gap-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-style-heading-main text-sds-base-default"
    }, title), subtitle ? /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-small text-sds-base-secondary"
    }, subtitle) : null)
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-h-[70vh] overflow-y-auto"
  }, children), footer ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4 flex items-center justify-end gap-3 border-t border-sds-base-default pt-4"
  }, footer) : null);
}